<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title style="background: #a0000a;" class="text-h5 darken-3 white--text">
            Rechazar proyecto seleccionado
          </v-card-title>
  
          <v-card-text>  
            <p class="text-center mt-4"> <b>Rechazar</b> proyecto seleccionado </p>
            <h5 class="text-center mb-0"> {{ dato.nombre_proyecto }} </h5>
            <p class="text-center"> {{ dato.sede_portal_name }} </p>

            <v-radio-group v-model="input.criterio_rechazo">
                <v-radio
                    v-for="(c,i) in criterios"
                    :key="i"
                    :label="c"
                    :value="c"
                />
                <v-text-field class="mt-4" counter v-if="isshowdetalle" label="Detalle el choque de segmento:" v-model.trim="data_extra" outlined dense/>
            </v-radio-group>

            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="background: #a0000a;" :disabled="loading" dark @click="enviar()"> rechazar </v-btn>
            <v-btn color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import { desaprobar_seleccionado } from '@/views/oferta_academica/servicios/seleccionService.ts';
import { criterios_rechazo_esam } from '@/views/oferta_academica/autoria/utils.ts';

export default {
    data() {
        return {
            loading: false,
            dialog: false,
            dato: {},
            criterios:['No me gusta','muy naco'],
            input: {},
            data_extra: '',
        };
    },
    computed:{
      isshowdetalle(){
        if(this.input.criterio_rechazo == 'CHOQUE DE SEGMENTO'){
          return true;
        }
        return false;
      }
    },
    methods: {
        async openmodal(row) { 
            const user = this.$store.state.DATA_USER
            this.dato = row
            this.input = {
              seleccionado_id: row.id,
              aprobado_por_id: user.id,
              criterio_rechazo: null,
            }
            this.criterios = criterios_rechazo_esam()
            this.dialog = true
        },

        async enviar(){ 
            if(!this.input.criterio_rechazo){
                this.$root.$notify.show('seleccione un criterio de rechazo', { color: '#980000', x: 'left' });
                return;
            }
            let texto = this.input.criterio_rechazo;
            if(this.input.criterio_rechazo == 'CHOQUE DE SEGMENTO'){
              if(!this.data_extra) {
                this.$root.$notify.show('detalle el choque de segmento', { color: '#980000', x: 'left' });
                return;
              }else{
                texto += ' '+this.data_extra;
              }
            }
            this.desaprobar(texto)
        }, 

        async desaprobar(texto){
            this.loading = true
            const desa = {
              seleccionado_id: this.input.seleccionado_id,
              texto_rechazo: texto
            }
            const r = await desaprobar_seleccionado(desa)
            if(r && r.desaprobar_seleccionado){ 
              this.$root.$notify.show('rechazado', { color: '#009800', x: 'left' });
              this.dialog = false
              this.dato.aprobado_por_id = r.desaprobar_seleccionado.aprobado_por_id
              this.dato.fecha_aprobacion = r.desaprobar_seleccionado.fecha_aprobacion
              this.dato.estado_aprobacion = r.desaprobar_seleccionado.estado_aprobacion
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              });  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(r);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
              
            }
            
            this.loading = false
        }
    }
};
</script>
  